import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import Login from "../components/Login.vue";
import { hasCompatibleKeychain } from "../unit/SteemKeychain";
import { extractLoginData, getAccount, logout as lg } from "../unit/UserUtil";
export default {
  name: "UserLoginView",
  components: {
    Login: Login
  },
  data: function data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      showLoginModel: false,
      isLogin: false,
      isHaveKeychain: false,
      headImg: "/img/theme/user-static.png",
      userName: "",
      watchShowSidebar: false
    };
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu: function toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    loginScuccess: function loginScuccess() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.showLoginModel = false;

                _this.loadAccount();

                _this.$bus.emit("loginScuccess");

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadAccount: function loadAccount() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loginData, _account$profile_imag, account;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loginData = extractLoginData();

                if (!loginData) {
                  _context2.next = 8;
                  break;
                }

                _this2.isLogin = true;
                _context2.next = 5;
                return getAccount(loginData[0]);

              case 5:
                account = _context2.sent;
                _this2.headImg = (_account$profile_imag = account.profile_image) !== null && _account$profile_imag !== void 0 ? _account$profile_imag : _this2.headImg;
                _this2.userName = account.name;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    logout: function logout() {
      this.isLogin = false;
      lg();
      this.headImg = "/img/theme/user-static.png";
      this.userName = "";
      this.$router.push({
        path: "/"
      });
      this.$bus.emit("closeDropdown");
      this.$bus.emit("logout");
    }
  },
  watch: {
    showLoginModel: function showLoginModel() {
      this.isHaveKeychain = hasCompatibleKeychain();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.loadAccount();

              _this3.$bus.on("loginScuccess", function () {
                _this3.loadAccount();
              });

              _this3.$bus.on("openLogin", function () {
                _this3.showLoginModel = true;
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};